/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Cropper from 'material/imageupload/components/cropper/cropper_container';
import Controls from 'material/imageupload/components/controls/controls';
import Input from 'material/imageupload/components/input/input_container';
import Gif from 'material/imageupload/components/gif/gif';
// styles
import injectSheet from 'react-jss';
import styles from 'material/imageupload/imageupload_styles';

/* ========== ~~~~~~~~~~ IMAGE SELECTOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ImageUpload extends Component {
	constructor(props) {
		super(props);
		this.state = {
			canvas: null,
			image: null,
			imageSrc: null,
			zoom: 2.5,
			file: null,
			isGif:false
		};
	};
	//creates blob and image url for uploaded images
	getCroppedImg = (fileName, preview) => {
		const canvas = this.state.canvas;
		if(!this.state.isGif){
            new Promise((resolve, reject) => {
                canvas.toBlob(file => {
                    file.name = fileName;
                    resolve(file);
                }, 'image/png');
            }).then(blob => {
                if (preview) {
                    this.setState({ blob: blob });
                    this.props.previewImage(URL.createObjectURL(blob));
                } else {
                    this.props.processImage(blob);
                    this.setState({ imageSrc: null, image: null, zoom: 1 });
                }
            });
		}else{
            fetch(this.state.imageSrc)
                .then(res => res.blob())
                .then(blob => {
                    if (preview) {
                        this.setState({ blob: blob });
                        this.props.previewImage(URL.createObjectURL(blob));
                    } else {
                        this.props.processImage(blob);
                        this.setState({ imageSrc: null, image: null });
                    }
				})
		}

	};
	onSelectFile = e => {
        const file = e.target.files[0];
        //will be replaced with alert action
        if(file.size/1024/1024 > 5){
            this.props.sendMessage('This image is too large. File size must be under 5MB.');
            return null;
        }
        if(file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif' ){
            this.props.sendMessage('File type not supported. Please use PNG, JPEG, or GIF file format.');
            return null
        }


        this.setState({ file: e.target.files[0].name });
		if (e.target.files && e.target.files.length > 0) {
			const reader = new FileReader();
			reader.addEventListener(
				'load',
				() =>{this.setState({
                    imageSrc: reader.result,
                    image: reader.result,
                    isGif: (file.type === 'image/gif')
                });
				(file.type === 'image/gif') ? this.getCroppedImg(this.state.file, true) : this.setState({isGif:false});
				},false
			);
			reader.readAsDataURL(e.target.files[0])
		}




	};
	setCanvas = canvas => {
		this.setState({ canvas: canvas });
	};
	onZoomChange = zoom => {
		this.setState({ zoom: zoom });
	};
	onPreview = () => {
		this.getCroppedImg(this.state.file, true);
	};
	onSubmit = () => {
		this.getCroppedImg(this.state.file,false);
	};
	onCancel = () => {
		this.setState({ imageSrc: null, image: null, zoom: 1 });
        this.props.previewImage(null);
	};
	//is used to toggle image window when logo selector is active
	toggleActiveSelection = () => {
		if (this.props.logo) {
			this.setState({
				canvas: null,
				image: null,
				imageSrc: null,
				zoom: 1,
				file: null,
			});
		}
        this.props.previewImage(null);
	};
	render() {
		let { logo, imageSize, cropSize } = this.props;
		return (
			<div className={`imageupload active-${!!this.state.imageSrc} ${this.props.classes.imageupload}`}>
				{!this.state.imageSrc && (<Input
					onSelect={this.onSelectFile}
					logo={logo}
				/>)}
				{this.state.imageSrc && (<div className={`cropperSlider`}>
						{ this.state.isGif ? <Gif src={this.state.imageSrc} /> : <Cropper
						imageSize={imageSize}
						image={this.state.imageSrc}
						width={cropSize.width}
						height={cropSize.height}
						zoom={this.state.zoom}
						previewMethod={this.onPreview}
						setCanvas={this.setCanvas}
						toggleActiveSelection={this.toggleActiveSelection}
						logo={logo}

					/>}
					<Controls
						isGif={this.state.isGif}
						zoom={this.state.zoom}
						zoomChange={this.onZoomChange}
						submit={this.onSubmit}
						cancel={this.onCancel}
                        onNewSelect={this.onSelectFile}
					/>
				</div>)}
			</div>
		);
	};
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageUpload);
